<template>
  <div>
    <h2 class="mb-4">Children's guardian</h2>
    <h3 class="mb-2">What is the role of a guardian?</h3>
    <ul class="mb-6">
      <li>
        A Guardian is the person who is legally appointed to have parental
        rights and responsibilities of your minor child/children if there is no
        existing parent or guardian at the time of your passing.
      </li>
      <li>
        <span class="text-highlight"
          >&nbsp;<b>Do not</b> appoint an <b>existing parent</b> or
          <b>current legal guardian</b> of the child/children. &nbsp;</span
        >
      </li>
      <li>
        You can appoint a sole guardian, co-guardians or no guardians in terms
        of this will. Co-guardians are usually a couple who live together and
        who would jointly take care of the child/children.
      </li>
      <li>
        We recommend you appoint someone who resides in {{ country }}. Should
        you insist on appointing a guardian who lives elsewhere, we recommend
        you seek advice from a family lawyer.
      </li>
      <li>
        The people you appoint here will be the guardian(s) for all your minor
        children.
      </li>
    </ul>

    <PeopleList
      :people="relations.guardians"
      :testator="testator"
      relation="CHILD_GUARDIAN"
      :people-for-dialog="peopleForDialog"
      :limit="2"
    />

    <div class="button-container">
      <DefaultButton
        @defaultButtonClicked="redirectBack"
        :small="true"
        :callout="'left'"
      />
      <GradientButton
        :title="'Next'"
        :small="true"
        :callout="'right'"
        @gradientButtonClicked="redirectToNext"
      />
    </div>
  </div>
</template>

<script>
  import PeopleList from './PeopleList.vue';
  import { getAge } from '../../constants/js/people';

  export default {
    name: 'ChildrensGuardian',
    components: {
      PeopleList,
    },
    props: {
      testator: { type: Object, required: true },
      relations: { type: Object, required: true },
    },
    data() {
      return {
        wizard: this.$route.query.peopleWizard,
      };
    },
    computed: {
      peopleForDialog() {
        return this.testator.people.map(p => {
          if (this.relations.guardians.includes(p)) {
            return {
              ...p,
              disabledMessage: 'This person is already a child guardian',
            };
          } else if (
            this.relations.children.includes(p) &&
            getAge(p.dateOfBirth) < 18
          ) {
            return {
              ...p,
              disabledMessage: 'Children cannot be guardians if under 18',
            };
          } else {
            return p;
          }
        });
      },
      country() {
        return this.testator.willCountry == 'GB'
          ? 'the United Kingdom'
          : 'South Africa';
      },
    },
    methods: {
      redirectToNext() {
        if (this.wizard == 'guardians') {
          this.$router.push({ name: 'PeopleOverview', hash: '#children' });
        } else {
          if (this.testator.willCountry == 'GB') {
            this.$router.push('executor');
          } else {
            this.$router.push('trust');
          }
        }
      },
      redirectBack() {
        if (this.wizard == 'guardians') {
          this.$router.push({ name: 'PeopleOverview', hash: '#children' });
        } else {
          this.$router.push('add-children');
        }
      },
    },
  };
</script>

<style scoped>
  .button-container {
    margin-top: 40px;
    display: flex;
    gap: 20px;
  }
</style>
